import axios from "axios";
import { ARTICLES as STATIC_ARTICLES } from "@/data/insights";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CACHE_TTL = 60 * 1000;
let cache = null;
let cachedAt = 0;

// Runtime fallback: if the API is unreachable, the original static articles render instead.
export async function fetchArticles() {
  if (cache && Date.now() - cachedAt < CACHE_TTL) return cache;
  try {
    const r = await axios.get(`${API}/articles`, { timeout: 8000 });
    if (Array.isArray(r.data) && r.data.length > 0) {
      cache = r.data;
      cachedAt = Date.now();
      return cache;
    }
  } catch (e) {
    // fall through to static
  }
  return cache || STATIC_ARTICLES;
}

export function staticArticles() {
  return STATIC_ARTICLES;
}
